import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { units } from '../../utils/spacing';
import { FontSizes, FontWeights } from '../../utils/typography/types';
import Text from '../Text';
import { TextElements } from '../Text/types';
import { gradients, PaletteColor } from '../ThemeProvider';

interface BadgeTextProps {
	className?: string;
	$borderColor: PaletteColor;
	$backgroundColor: PaletteColor;
	$textColor: PaletteColor;
}

export const GradientTextEnabler = styled.span<{
	$textColor: PaletteColor;
}>`
	${p => {
		if (Object.keys(gradients).includes(p.$textColor)) {
			return css`
				background: ${palette(p.$textColor)};
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				background-clip: text;
				text-fill-color: transparent;
			`;
		}
	}}
`;

export const BadgeText = styled(Text)<BadgeTextProps>`
	width: ${ifProp('fullWidth', '100%', 'fit-content')};
	color: ${p => (Object.keys(gradients).includes(p.$textColor) ? palette('text') : palette(p.$textColor))};
	padding: calc(0.25rem - 1px) calc(0.5rem - 1px);
	min-height: ${units(3.5)};
	min-width: ${units(3.5)};
	border-radius: 6.25rem;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 0;
	background: ${p => palette(p.$backgroundColor)};
	border: 1px solid ${p => palette(p.$borderColor)};
`;

export const BadgeComponent = styled(BadgeText).attrs({
	el: TextElements.Div,
	size: FontSizes.sm,
	weight: FontWeights.Medium,
})``;
